export default __webpack_public_path__ + "static/media/017-toaster.3f91ca2a.svg";